import React, {useEffect, useState} from 'react';
import ResetPassword from "../components/reset/reset-password";
import * as TagManager from "react-gtm-module";
import {
    _checkEmailIfRegistered,
    _decryptResetPasswordToken,
    _getUser, _resetPassword,
    _storeUser
} from "../store/user/service";
import {connect} from "react-redux";
import {
    _hideModal,
    _hideSpinner,
    _setCpToken,
    _showModal,
    _showSpinner,
    _verifyOtpAndGetUserDetail
} from "../store/system/service";
import useConfig from "../components/qnect-ui/qnect-config";
import LinkValidationModal from "../components/link-validation-modal";
import VerificationCodeDialog from "../components/custom/login/verification-code-dialog";
import {customReplaceAll} from "../utils/utility";
import TooManyFailedAttemptsDialog from "../components/custom/login/too-many-failed-attempts-dialog";


const ResetPasswordPage = (props) => {
    const params = new URLSearchParams(props.history.location.search);
    const cfg = useConfig();
    const [openLinkValidation, setOpenLinkValidation] = useState(false);
    const [linkValidationMessageKey, setLinkValidationMessageKey] = useState("invalidLink");
    const [resetVerifyOpen, setResetVerifyOpen] = useState(false);
    const [maskedEmail, setMaskedEmail] = useState("");
    const [otpValue, setOtpValue] = useState("");
    const [otpErrorMessage, setOtpErrorMessage] = useState("");
    const [failedOpen, setFailedOpen] = useState(false);
    const [resendTimer, setResendTimer] = useState(0);
    const [resendTimerIntervalId, setResendTimerIntervalId] = useState(null);
    const [passwordMinLength, setPasswordMinLength] = useState();
    const [passwordLimit, setPasswordLimit] = useState();
    useEffect(() => {
        let token = params.get('token');
        let iv = params.get('iv');

        TagManager.dataLayer({
            dataLayer: {
                event: 'vpageview',
                pageStep: 'Reset Password',
                vPath: '/resetPassword'
            }
        });

        props.showSpinner();
        props.decryptResetPasswordToken(token, iv).then((response) => {
            if (response.status === 'SUCCESS') {
                props.user.email = response.email;
                props.setCpToken(response.token);
                props.storeUser(props.user);

                let val = response.email.split('@')[0];
                let regexToUse = val.length > 4 ? /^.*(?=....@)/g : /^.*(?=@)/g;
                let emailMasked = customReplaceAll(regexToUse, response.email, '•');
                setMaskedEmail(emailMasked);

                resetResendTimer();
                setResetVerifyOpen(true);
            } else if (response.status === 'LINK_LOCKED') {
                setFailedOpen(true);
            } else if (response.status === 'LINK_EXPIRED') {
                setLinkValidationMessageKey('expiredForgotPasswordLink');
                setOpenLinkValidation(true);
            } else {
                setLinkValidationMessageKey('invalidLink');
                setOpenLinkValidation(true);
            }

            props.hideSpinner();
        }, () => {
            setLinkValidationMessageKey('invalidLink');
            setOpenLinkValidation(true);
            props.hideSpinner();
        });
    }, []);

    const handleLoginRedirection = () => {
        props.history.push('/login');
        props.hideModal();
    }

    const handleResetVerifyOtp = () => {
        props.showSpinner();
        props.verifyOtpAndGetUserDetail(otpValue, props.user.email).then((response) => {
            console.log(response);
            if (response.success) {
                console.log("otp verified");
                setResetVerifyOpen(false);
                setPasswordMinLength(response.passwordMinLength);
                setPasswordLimit(response.passwordLimit);
            } else if (response.locked) {
                setResetVerifyOpen(false);
                setFailedOpen(true);
            } else {
                setOtpErrorMessage(cfg("otp.errorMessages.invalidOTP"));
            }
            props.hideSpinner();
        }, (error) => {
            setOtpErrorMessage(cfg("otp.errorMessages.invalidOTP"));
            props.hideSpinner();
        })
    }

    const handleResend = () => {
        if (resendTimer === 0) {
            props.showSpinner();
            setOtpValue("");
            setOtpErrorMessage('');
            props.checkEmailIfRegistered(props.user.email, props.country).then((response) => {
                if (response.isExisting === 'true') {
                    let otpToken = {
                        iv: response.iv,
                        token: response.token
                    }
                    props.setOtpToken(otpToken);
                }
                props.hideSpinner();
            });
            resetResendTimer();
        }
    }

    const resetResendTimer = () => {
        if (resendTimerIntervalId) {
            clearInterval(resendTimerIntervalId);
        }
        // email timer
        setResendTimer(600);
        let setTimerInterval = setInterval(() => {
            setResendTimer((prevTimer) => {
                if (prevTimer > 0) {
                    return prevTimer - 1;
                } else {
                    clearInterval(setTimerInterval);
                    return 0;
                }
            });
        }, 1000);
        setResendTimerIntervalId(setTimerInterval);
    }

    return (
        <div>
            <ResetPassword props={props}
                           passwordMinLength={passwordMinLength}
                           passwordLimit={passwordLimit}/>

            <LinkValidationModal
                open={openLinkValidation}
                messageKey={linkValidationMessageKey}
                onClose={handleLoginRedirection}
            />

            <VerificationCodeDialog
                open={resetVerifyOpen}
                maskedEmail={maskedEmail}
                onClose={() => setResetVerifyOpen(false)}
                onConfirm={handleResetVerifyOtp}
                onOther={() => {
                    setResetVerifyOpen(false);
                }}
                value={otpValue}
                setValue={setOtpValue}
                errorMessage={otpErrorMessage}
                setOtpErrorMessage={setOtpErrorMessage}
                handleResend={handleResend}
                resendTimer={resendTimer}
                cfg={cfg}
                lang={props.lang}
            />

            <TooManyFailedAttemptsDialog
                open={failedOpen}
                onClose={() => setFailedOpen(false)}
                cfg={cfg}
            />

        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        user: _getUser(state)
    }
}

const mapDispatchToProps = {
    decryptResetPasswordToken: _decryptResetPasswordToken,
    verifyOtpAndGetUserDetail: _verifyOtpAndGetUserDetail,
    checkEmailIfRegistered: _checkEmailIfRegistered,
    setCpToken: _setCpToken,
    storeUser: _storeUser,
    showSpinner: _showSpinner,
    hideSpinner: _hideSpinner,
    showModal: _showModal,
    hideModal: _hideModal,
    resetPassword: _resetPassword,
};


export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage);
